.field { margin-bottom: 22px; }
.field:last-child { margin-bottom: 0; }

.label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: var(--ink);
  margin-bottom: 7px;
  letter-spacing: .01em;
}

.req { color: var(--red); margin-left: 2px; }

.hint {
  font-size: 13px;
  color: var(--muted2);
  margin-top: 5px;
  line-height: 1.55;
}

.inputWrap {
  position: relative;
}

.inputWrap input {
  width: 100%;
  padding: 11px 80px 11px 14px;
  border: 1px solid var(--border);
  border-radius: 4px;
  font-size: 15px;
  font-family: 'Roboto', sans-serif;
  color: var(--ink);
  background: white;
  outline: none;
  transition: border-color .15s, box-shadow .15s;
}

.inputWrap input:focus {
  border-color: var(--blue);
  box-shadow: 0 0 0 2px rgba(26,115,232,.15);
}

.addBtn {
  position: absolute;
  right: 7px;
  top: 50%;
  transform: translateY(-50%);
  background: var(--blue-lt);
  color: var(--blue);
  border: none;
  padding: 5px 10px;
  border-radius: 3px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  font-family: 'Google Sans', sans-serif;
  transition: background .1s;
}

.addBtn:hover { background: var(--blue-mid); }

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 10px;
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: var(--blue-lt);
  border: 1px solid var(--blue-mid);
  border-radius: 16px;
  padding: 4px 4px 4px 11px;
  font-size: 13.5px;
  color: var(--blue);
}

.chipWrap {
  display: inline-flex;
  flex-direction: column;
  gap: 3px;
  max-width: 320px;
}

.chipWarning {
  border-color: var(--yellow);
}

.chipWarningText {
  font-size: 11.5px;
  color: var(--yellow);
  font-weight: 500;
  line-height: 1.35;
  padding-left: 2px;
}

.chipRemove {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: none;
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--blue);
  transition: background .1s;
  flex-shrink: 0;
  padding: 0;
}

.chipRemove:hover { background: rgba(26,115,232,.2); }

.inputWrapSingle input {
  padding-right: 14px;
}
